import { GlobalContext } from "context/GlobalContext";
import { useContext } from "react";
import { toast } from "react-toastify";
import { BackArrow, TopNewsIcon } from "themes/Icon";
import TagComp from "themes/elements/Tag";
import { isPermit } from "utils/permissionCheck";
import style from "../../details.module.scss";
import ApprovalBtn from "./actionButtons/approvalBtn";
import NonApprovalButtons from "./actionButtons/nonApprovalBtn";

function Header(props) {
  const {
    handleClose,
    selectedNews,
    isHistory,
    Approval,
    onEdit,
    setReject,
    status,
    setApprove,
    setDlt,
    tabActive,
  } = props;

  const { state } = useContext(GlobalContext);
  const { colorData } = state;

  const getColorByTagColor = (tagColor) => {
    const colorItem = colorData.find((item) => item.id === tagColor);
    return colorItem ? colorItem.value : "";
  };

  return (
    <>
      <div
        className={`flex gap-2 align-center w-full ${style["title-container"]}`}
      >
        <span onClick={handleClose} className={`${style["back-icon"]}`}>
          <BackArrow />
        </span>
        {selectedNews?.top_news && (
          <span className="top-news-details">
            <TopNewsIcon />
          </span>
        )}
        <div
          className={`flex wrap align-center gap-4 w-full ${style["title-chip-wrapper"]}`}
        >
          <h2 className="page-title-details">{selectedNews?.title}</h2>
          <TagComp color={getColorByTagColor(selectedNews?.tag_color)}>
            {selectedNews?.category}
          </TagComp>
        </div>
      </div>
      {!isHistory && tabActive !== "2" && (
        <div className={`flex align-center gap-4 ${style["button-wrapper"]}`}>
          {Approval && status === null && isPermit(3, "approve_reject") ? (
            <ApprovalBtn
              onEdit={onEdit}
              setReject={setReject}
              setApprove={() => {
                if (selectedNews?.banner_img) {
                  setApprove(true);
                } else {
                  toast.warning("Image/Thumbnail is required.");
                }
              }}
              selectedNews={selectedNews}
            />
          ) : (
            <NonApprovalButtons
              onEdit={onEdit}
              setDlt={setDlt}
              selectedNews={selectedNews}
              tabActive={tabActive}
            />
          )}
        </div>
      )}
    </>
  );
}

export default Header;
